"use strict";
var flyoutTimeline = null;

// .closest
if (!Element.prototype.matches) {
Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
Element.prototype.closest = function(s) {
  var el = this;

  do {
    if (el.matches(s)) return el;
    el = el.parentElement || el.parentNode;
  } while (el !== null && el.nodeType === 1);
  return null;
};
} 

// throttle
function throttle(delay, fn) {
var last, deferTimer;
return function() {
  var context = this, args = arguments, now = +new Date;
  if(last && last + delay > now)       {
    clearTimeout(deferTimer);
    deferTimer = setTimeout(function() { last = now; fn.apply( context, args ); }, delay);
  } else {
    last = now;
    fn.apply(context, args);
  }
};
}

function getTransitionDuration (element) {
return parseFloat(window.getComputedStyle(element).getPropertyValue('transition-duration')) * 1000;
}

window.oaBackdrop = (function () {

var backdrop = document.getElementById('oa-bckdrp19'),
    classBackdropHidden = 'oa-bckdrp19--hidden',
    classBackdropSidenav = 'oa-bckdrp19--sidenav',
    classBackdropSearch = 'oa-bckdrp19--search',
    classBackdropFlyout = 'oa-bckdrp19--flyout';

function hide () {
  backdrop.classList.add(classBackdropHidden);
  backdrop.classList.remove(classBackdropSidenav);
  backdrop.classList.remove(classBackdropSearch);
  backdrop.classList.remove(classBackdropFlyout);
}

function show () {
  backdrop.classList.remove(classBackdropHidden);
}

function showForSidenav () {
  backdrop.classList.add(classBackdropSidenav);
  backdrop.classList.remove(classBackdropSearch);
  backdrop.classList.remove(classBackdropFlyout);
  show();
}

function showForSearch () {
  backdrop.classList.remove(classBackdropSidenav);
  backdrop.classList.add(classBackdropSearch);
  backdrop.classList.remove(classBackdropFlyout);
  show();
}

function showForFlyout () {
  backdrop.classList.remove(classBackdropSidenav);
  backdrop.classList.remove(classBackdropSearch);
  backdrop.classList.add(classBackdropFlyout);
  show();
}

return {
  hide: hide,
  show: show,
  showForSidenav: showForSidenav,
  showForSearch: showForSearch,
  showForFlyout: showForFlyout
}

})();


// TODO: Measure scroll bar width and set it as padding on body?

window.oaMenu = (function (menu, before, after) {

var classMenuMobileOpen = 'oa-header__sidenav--open',
    classHtmlMenuOpened = 'oa-menumobile--opened',
    classHtmlNoOverflow = 'oa-nooverflow';

var html = document.documentElement,
    backdrop = document.getElementById('oa-bckdrp19');

var pagecenter = document.getElementById('page-center');

var isOpen = false;

var duration = getTransitionDuration(pagecenter);
var timer;

function resetTimeout() {
  if (timer) {
    clearTimeout(timer);
  }
}

function showMenu () {
  isOpen = true;
  resetTimeout();
  menu.classList.add(classMenuMobileOpen);
  if (typeof before === 'function') {
    before.call(null, isOpen); 
  }
  html.classList.add(classHtmlNoOverflow);
  html.classList.add(classHtmlMenuOpened);
  window.oaBackdrop.showForSidenav();
  timer = setTimeout(function () {
    if (typeof after === 'function') {
      after.call(null, isOpen); 
    }
  }, duration);
}

function hideMenu () {
  isOpen = false;
  resetTimeout();
  if (typeof before === 'function') {
    before.call(null, isOpen); 
  }
  html.classList.remove(classHtmlMenuOpened);
  window.oaBackdrop.hide();
  timer = setTimeout(function () {
    html.classList.remove(classHtmlNoOverflow);
    menu.classList.remove(classMenuMobileOpen);
    if (typeof after === 'function') {
      after.call(null, isOpen); 
    }
  }, duration);
}

function toggleMenu () {
  isOpen = !isOpen;
  if (isOpen) {
    showMenu();
  } else {
    hideMenu();
  }
}

function onBackdropClicked (event) {
  event.preventDefault();
  isOpen = true;
  toggleMenu();
}

document.addEventListener('DOMContentLoaded', function (event) {
  backdrop.addEventListener('click', onBackdropClicked);

  // Bind header search toggles to vue-search instance (the mobile one only renders when enabled in header.liquid)
  var headerSearchToggles = document.querySelectorAll('#headersearchtoggle, #headersearchtoggle-mobile');
  // Not an index loop: theme-check parses .js.liquid as LiquidHTML, and a less-than sign followed by a letter opens a tag it never sees closed.
  Array.prototype.forEach.call(headerSearchToggles, function (toggle) {
    toggle.addEventListener('click', function () {
      if (typeof vuesearch !== 'undefined' && vuesearch.toggleSearch) {
        vuesearch.toggleSearch();
      }
    });
  });
});


return {
  show: showMenu,
  hide: hideMenu,
  toggle: toggleMenu,
};

});



window.oaHeader = (function () {

var header = document.getElementById('oa-hdr19'),
    headerMain = document.querySelector('.oa-hdr19-main'),
    headerSidenav = document.getElementById('header-sidenav');

//
//
//
var gradientScroll = (function () {
  var disabled = false;
  var headerTop = header.querySelector('.oa-hdr19-top');
  var heroBanner = document.querySelector('.oa-hero-banner.oa-hero-banner--offset .oa-hero-banner__content > *');
  
  var classGradient = 'oa-hdr19-top--gradient';
  var offset;
  
  function updateOffset() {
    if (disabled) {
      return;
    }
    offset = heroBanner.offsetTop + heroBanner.clientHeight - (2 * headerTop.clientHeight);
  }
  
  function updateHeaderGradient() {
    if (disabled) {
      return; 
    }
    if (window.pageYOffset >= offset) {
      headerTop.classList.remove(classGradient);
    } else {
      headerTop.classList.add(classGradient);
    }
  }

  if (headerTop.classList.contains(classGradient) && heroBanner != null) {
    updateOffset();
    updateHeaderGradient();
    window.addEventListener('resize', function (event) {
      updateOffset();
    }, false);
    window.addEventListener('scroll', function (event) {
      updateHeaderGradient();
    }, false);
    }
  
  return {
    disable: function () {
      disabled = true; 
    },
    enable: function () {
      disabled = false; 
    }
  }
})();

//
// MENU TOGGLE
//
var menuToggle = (function () {

  var banner = document.getElementById('oa-hdr19-banner');

  var classHeaderToggled = 'oa-hdr19-top__toggle--toggled',
      toggle;

  var pagecenter = document.getElementById('page-center'),
      classPagecenterOntop = 'page-center--ontop';
  var y;

  var onResize = throttle(150, function () {
    window.oaHeaderSidenav.hide();
  });

  function afterToggle (isOpen) {
    if (isOpen) {
      setTimeout(function () {
        window.addEventListener('resize', onResize, { capture: true, passive: true });
      }, 16);
    } else {
      window.removeEventListener('resize', onResize, { capture: true, passive: true });
      setTimeout(function () {
        pagecenter.classList.remove(classPagecenterOntop);
        sidenav.resetActivePanel();
      }, 0);
    }
  }

  function beforeToggle (isOpen) {
    if (isOpen) {
    y = window.scrollY || window.pageYOffset;
    var h = window.innerHeight;
    gradientScroll.disable();

      /*
    const isFirefox = typeof InstallTrigger !== 'undefined';
    if (isFirefox) {
      y = 22;
    }*/


    header.style.setProperty('top', y + 'px', 'important');
    // header.style.setProperty('position', 'absolute', 'important');
    pagecenter.classList.add(classPagecenterOntop);

    pagecenter.style.position = 'fixed';
    pagecenter.style.top = (-y) + 'px';
    pagecenter.style.height = (y + h) + 'px';

   

    toggle.classList.add(classHeaderToggled);
  } else {
    toggle.classList.remove(classHeaderToggled);
    pagecenter.style.position = '';
    pagecenter.style.height = '';
    pagecenter.style.top = '';
    header.style.top = '';


    window.scrollTo(0, y);
    setTimeout(function () {
      var restoredY = window.scrollY || window.pageYOffset;
      if (restoredY !== y) {
        window.scrollTo(0, y);
      }
    }, 0);
    gradientScroll.enable();
  }
}
  window.oaHeaderSidenav = window.oaMenu(headerSidenav, beforeToggle, afterToggle);

  function setupScrollBackground(open) {
        const pagecenter = document.getElementById('page-center');
        const classPagecenterOntop = 'page-center--ontop';

        if (open) {
          const y = window.scrollY || window.pageYOffset;
          const h = window.innerHeight;

            
           

          pagecenter.dataset.scrollY = y;
          pagecenter.classList.add(classPagecenterOntop);

       
    const isFirefox = typeof InstallTrigger !== 'undefined';
         if (isFirefox) {
          pagecenter.style.position = 'sticky';
         }else {
          pagecenter.style.position = 'fixed';
        }
          pagecenter.style.top = (-y) + 'px';
          pagecenter.style.height = (y + h) + 'px';
        } else {
          const y = parseInt(pagecenter.dataset.scrollY || 0, 10);

          pagecenter.classList.remove(classPagecenterOntop);
          pagecenter.style.position = '';
          pagecenter.style.height = '';
          pagecenter.style.top = '';
          window.scrollTo(0, y);

          pagecenter.removeAttribute('data-scroll-y');
        }
}

window.oaHeaderDownnav = function(toggle) {
  const classHeaderToggled = 'oa-hdr19-top__toggle--toggled';
  const classMobileOpen = 'oa-downmenumobile--opened';
  const classMobileTransparent = 'oa-hdr19--transparent';
  const htmlEl = document.documentElement;
  const downnav = document.querySelector('.oa-header__collapse');
  const tabs = downnav.querySelectorAll('.oa-header__collapse-tab');
  const panels = downnav.querySelectorAll('.oa-header__collapse-submenu');
  const subMenues = document.querySelectorAll('.oa-header__collapse-under-submenu');
  const targetHeight = window.innerHeight - 56 + 'px';
  const headerItems = downnav.querySelectorAll('.oa-header__collapse--menu-item');

  // Animate Downnav Open/Close
  toggle.classList.toggle(classHeaderToggled);
  htmlEl.classList.toggle(classMobileOpen);
  if(document.getElementById('oa-hdr19').classList.contains(classMobileTransparent)){
  document.getElementById('oa-hdr19').classList.toggle(classMobileTransparent);
}
  const isOpening = htmlEl.classList.contains(classMobileOpen);

  const tl = gsap.timeline({ defaults: { overwrite: true } });



  if (isOpening) {
    setupScrollBackground(true);
    downnav.style.display = 'block';
    subMenues.forEach(el => {
      el.removeAttribute('style');
    });

    panels.forEach((panel, i) => {
      if (i === 0) panel.style.display = 'block';
      else panel.style.display = 'none';
    });

    // Initial states for tabs and panels
    gsap.set(tabs, { opacity: 0 });
    tabs.forEach(tab => {
      gsap.set(tab.querySelector('.oa-header__collapse-tab-underline'), { width: 0 });
    });
    panels.forEach((panel, i) => {
      gsap.set(panel.children, { opacity: 0, x: -20 });
    });
    document.querySelector('.oa-header__collapse-tab').classList.add('is-active');
    tl.fromTo(
      downnav,
      { height: 0 },
      {
        height: targetHeight,
        duration: 0.45,
        ease: 'power2.out'
      }
    )
    .to(
      tabs,
      {
        opacity: 1,
        duration: 0.19,
        stagger: 0.05,
        ease: 'power1.out'
      },
      "-=0.25"
    )
    .to(
      tabs[0].querySelector('.oa-header__collapse-tab-underline'),
      {
        width: "100%",
        duration: 0.35,
        ease: "power2.out"
      },
      "-=0.16"
    )
    .to(
      panels[0].children,
      {
        opacity: 1,
        x: 0,
        duration: 0.28,
        ease: "power2.out"
      },
      "-=0.18"
    );
    tl.call(() => {
      window.tlCallback();
    });
  } else {

    
    setupScrollBackground(false);
    // Animate out, then collapse
    const activeTab = downnav.querySelector('.oa-header__collapse-tab.is-active');
    if (activeTab) {
      tl.to(
        activeTab.querySelector('.oa-header__collapse-tab-underline'),
        { width: 0, duration: 0.10, ease: "power2.in" },
        0
      );
    }
    panels.forEach(panel => {
      tl.to(
        panel.children,
        {
          opacity: 0,
          x: -10,
          duration: 0.05,
          stagger: { each: 0.01, from: 'end' },
          ease: 'power1.in'
        },
        0
      );
    });
    tl.to(
      downnav,
      {
        height: 0,
        duration: 0.20,
        ease: 'power2.in',
        onComplete: () => { downnav.style.display = 'none'; }
      },
      0.30
    );
    tl.call(() => {
      window.tlCallback();
      document.querySelectorAll(".oa-header__collapse-tab").forEach(tab => {
         tab.removeAttribute("style");
         tab.classList.remove('is-active')
        });
      headerItems.forEach(el => {
        el.classList.remove('is-active');
      });
      oaSyncMenuLabels();
    });


/*reset*/
   

    
  }

  // --- Tab Switching with Animations ---
  tabs.forEach(tab => {
    tab.onclick = function() {
      if (tab.classList.contains('is-active')) return;

      // Reset tabs
      tabs.forEach(t => {
        t.classList.remove('is-active');
        gsap.set(t.querySelector('.oa-header__collapse-tab-underline'), { width: 0 });
      });
      tab.classList.add('is-active');

      // Panels
      const target = tab.dataset.tab;
      panels.forEach(panel => panel.style.display = 'none');
      const newPanel = downnav.querySelector(`.oa-header__collapse-submenu[data-panel="${target}"]`);
      newPanel.style.display = 'block';

      // Reset submenu item states
      gsap.set(newPanel.children, { opacity: 0, x: -20 });

      // Animate tab underline
      gsap.to(tab.querySelector('.oa-header__collapse-tab-underline'), {
        width: "100%",
        duration: 0.36,
        ease: "power2.out"
      });

      // Animate submenu items in
      gsap.to(newPanel.children, {
        opacity: 1,
        x: 0,
        duration: 0.24,
        ease: "power2.out"
      });
    }
  });


};

// The label button is each submenu toggle's control (its click bubbles to the list item's handler),
// so it carries the open state the list item's is-active class holds.
function oaSyncMenuLabels() {
  document.querySelectorAll('.oa-header__collapse--menu-item').forEach(item => {
    const label = item.querySelector('.oa-header__collapse--menu-label');
    if (label) label.setAttribute('aria-expanded', item.classList.contains('is-active'));
  });
}

window.oaHeaderCollapsibleInit = function() {
  if(!$('html').hasClass('header-version--a')){return;}


  const items = document.querySelectorAll('.oa-header__collapse--menu-item');

function closeSubmenu(submenu) {
  if (!submenu) return;
  gsap.killTweensOf(submenu);
  gsap.timeline()
    .to(submenu, {
      opacity: 0,
      x: -20,
      duration: 0.15,
      ease: 'power2.in'
    })
    .to(submenu, {
      height: 0,
      duration: 0.2,
      ease: 'power2.in',
      onComplete: () => {
        submenu.style.display = 'none';
        submenu.style.height = '';
      }
    });
}

function openSubmenu(submenu) {
  if (!submenu) return;
  gsap.killTweensOf(submenu);
  submenu.style.display = 'block';
  gsap.set(submenu, { opacity: 0, x: -20, height: 0 });
  gsap.timeline()
    .to(submenu, {
      height: 'auto',
      duration: 0.2,
      ease: 'power2.out'
    })
    .to(submenu, {
      opacity: 1,
      x: 0,
      duration: 0.10,
      ease: 'power2.out'
    });
}

items.forEach(item => {
  item.addEventListener('click', () => {
    const target = item.getAttribute('data-target');
    const submenu = document.querySelector(`.oa-header__collapse-under-submenu[data-under="${target}"]`);

    const wasActive = item.classList.contains('is-active');

    if (wasActive) {
      // If clicking the active item, just close it and stop (don't reopen)
      item.classList.remove('is-active');
      oaSyncMenuLabels();
      closeSubmenu(submenu);
      return;
    }

    // Otherwise, close others first
    document.querySelectorAll('.oa-header__collapse--menu-item.is-active')
      .forEach(activeItem => activeItem.classList.remove('is-active'));

    document.querySelectorAll('.oa-header__collapse-under-submenu')
      .forEach(sm => {
        if (sm !== submenu) closeSubmenu(sm);
      });

    // Open the clicked one
    item.classList.add('is-active');
    oaSyncMenuLabels();
    openSubmenu(submenu);
  });
});




  window.tlCallback = function () {
    const collapseFirstCategory = false;
      if(collapseFirstCategory){
        const activeTab = document.querySelector('.oa-header__collapse-tab.is-active');

        const tabName = activeTab.getAttribute('data-tab');
        const targetPanel = document.querySelector(`.oa-header__collapse-submenu[data-panel="${tabName}"] .oa-header__collapse--menu-item`);
        if (targetPanel) {
          targetPanel.click();
        }
      }
    }
}


  document.addEventListener('DOMContentLoaded', function () {
    window.oaHeaderCollapsibleInit();
    toggle = document.getElementById('headertoggle');
    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      if($('html').hasClass('header-version--a')){
        //console.log('show menu a');
        window.oaHeaderDownnav(this);
      }else{
        window.oaHeaderSidenav.toggle();
      }
    });
    // Escape closes the mobile menu, like the desktop flyouts. Reuses the click path so whichever
    // menu version is live closes the way it opened.
    document.addEventListener('keydown', function (event) {
      // defaultPrevented: a modal or dropdown opened from inside the menu already closed itself.
      if ((event.key !== 'Escape' && event.key !== 'Esc') || event.defaultPrevented) {
        return;
      }
      var html = document.documentElement.classList;
      // The filter and sort drawers borrow oa-menumobile--opened; collection-filter.js closes those.
      if (html.contains('oa-filtermobile--opened') || html.contains('oa-sortmobile--opened')) {
        return;
      }
      if (html.contains('oa-downmenumobile--opened') || html.contains('oa-menumobile--opened')) {
        event.preventDefault();
        toggle.click();
        toggle.focus();
      }
    });
  }, { passive: true });

})();

 

//
// SIDENAV
//
var sidenav = (function () {

  var selectorSidenavPanelLinks = '.oa-header__sidenav__main__link[href*="#"]',
      selectorSidenavPanel = '.oa-header__sidenav__main__panel',
      classSidenavLinkPrev = 'oa-header__sidenav__main__link--prev',
      classSidenavLinkNext = 'oa-header__sidenav__main__link--next',
      classSidenavPanelHidden = 'oa-header__sidenav__main__panel--hidden',
      classSidenavPanelOpened = 'oa-header__sidenav__main__panel--opened',
      classSidenavPanelSubopened = 'oa-header__sidenav__main__panel--subopened';

  var toplink = document.getElementById('headersidenav-toplink');

  var duration;
  var timer;

  function resetTimeout() {
    if (timer) {
      clearTimeout(timer);
    }
  }

  function getCurrentPanel (link) {
    return link.closest(selectorSidenavPanel);
  }

  function getTargetPanel (link) {
    return document.getElementById(link.getAttribute('href').substr(1));
  }

  function showPrevPanel (panel, prevPanel) {
    resetTimeout();

    prevPanel.classList.remove(classSidenavPanelHidden);

    setTimeout(function () {
      panel.classList.remove(classSidenavPanelOpened);
      prevPanel.classList.remove(classSidenavPanelSubopened);
      prevPanel.classList.add(classSidenavPanelOpened);
    }, 16);  

    timer = setTimeout(function () {
      panel.scrollTop = 0;
      panel.classList.add(classSidenavPanelHidden);
    }, duration);
  }

  function showNextPanel (panel, nextPanel) {
    resetTimeout();

    nextPanel.classList.remove(classSidenavPanelHidden);

    setTimeout(function () {
      panel.classList.add(classSidenavPanelSubopened);
      nextPanel.classList.add(classSidenavPanelOpened);
    }, 16);

    timer = setTimeout(function () {
      panel.scrollTop = 0;
      panel.classList.add(classSidenavPanelHidden);
    }, duration);
  }

  function isPrevLink (link) {
    return link.classList.contains(classSidenavLinkPrev);
  }

  function isNextLink (link) {
    return link.classList.contains(classSidenavLinkNext);
  }

  function onLinkClicked (event) {
    event.preventDefault();
    if (isPrevLink(this)) {
      showPrevPanel(getCurrentPanel(this), getTargetPanel(this));
    } else if (isNextLink(this)) {
      showNextPanel(getCurrentPanel(this), getTargetPanel(this));
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    duration = getTransitionDuration(document.querySelector(selectorSidenavPanel));
    var links = document.querySelectorAll(selectorSidenavPanelLinks);
    Array.prototype.slice.call(links).forEach(function (link) {
      link.addEventListener('click', onLinkClicked);
    });
  }, { passvie: true });

  return {
    resetActivePanel: function () {
      var mainPanel = document.getElementById('sidenav-main');
      mainPanel.classList.remove(classSidenavPanelSubopened);
      mainPanel.scrollTop = 0;
      mainPanel.classList.remove(classSidenavPanelHidden);
      var otherPanels = document.querySelectorAll(selectorSidenavPanel);
      Array.prototype.slice.call(otherPanels).forEach(function (panel) {
        if (panel === mainPanel) {
          return; 
        }
        panel.scrollTop = 0;
        panel.classList.add(classSidenavPanelHidden);
        panel.classList.remove(classSidenavPanelOpened);
        panel.classList.remove(classSidenavPanelSubopened);
      });
    }
  }

})();

//
// CHOOSE REGION
//  
var chooseRegion = (function () {

  var selectorHeaderMainCountryIcon = '.oa-hdr19-main__right__link__countryicon',
      selectorHeaderMainTransparentCountryIcon = '.oa-hdr19-main__top__link__countryicon',
      selectorHeaderSidenavCountryIcon = '.oa-header__sidenav__main__countryicon';

  function setCountryIcon (selector, src) {
    var icon = document.querySelector(selector);
    if (!icon) {
      return;
    }
    icon.dataset.src = src;
    icon.src = src;
    icon.style.opacity = 1;
  }

  return {
    setCountryIcon: function (src) {
      setCountryIcon(selectorHeaderMainCountryIcon, src);
      setCountryIcon(selectorHeaderMainTransparentCountryIcon, src);
      setCountryIcon(selectorHeaderSidenavCountryIcon, src);
    }, 
  }

})();

//
// CART BADGE
// 
var cartBadge = (function () {
  var badge = document.getElementById('header-cart-badge'),
      badgeText = document.getElementById('header-cart-badge-text'),
      badgeCheck = document.getElementById('header-cart-badge-check'),
      cartLink = document.querySelector('a.oa-hdr19-top__cart'),
      classBadgeVisible = 'oa-hdr19-top__cart-badge--visible',
      classBadgeCheckVisible = 'oa-hdr19-top__cart-badge__check--visible',
      classBadgeCheckMovingFast = 'oa-hdr19-top__cart-badge__check--movingfast',
      classBadgeCheckMovingSlow = 'oa-hdr19-top__cart-badge__check--movingslow';

  var timer;

  function resetTimeout() {
    if (timer) {
      clearTimeout(timer);
    }
  }

  function updateText (count) {
    badgeText.innerText = count;
    if (parseInt(count) > 0 && !badge.classList.contains(classBadgeVisible)) {
      badge.classList.add(classBadgeVisible);
    } else if (parseInt(count) === 0) {
      badge.classList.remove(classBadgeVisible);
    }
    if (cartLink) {
      var labelTemplate = parseInt(count) === 1
        ? cartLink.getAttribute('data-cart-label-one')
        : cartLink.getAttribute('data-cart-label-many');
      if (labelTemplate) {
        cartLink.setAttribute('aria-label', labelTemplate.replace('{count}', count));
      }
    }
  }

  function loadCount () {
    return axios.get('/cart.json', { headers: { 'Cache-Control': 'no-cache, no-store', 'Pragma': 'no-cache', 'Expires': 0 } }).then(function (response) {
      var itemCount = response.data.item_count || 0;
      var totalPrice = response.data.total_price || 0;
      updateText(itemCount);
      return { 
        itemCount: itemCount,
        totalPrice: totalPrice,
      };
    });
  }

  function showCheck (targetElement, onFinish, quickadd) {
    resetTimeout();
    badgeCheck.classList.remove(classBadgeCheckVisible);
    badgeCheck.classList.remove(classBadgeCheckMovingFast);
    badgeCheck.classList.remove(classBadgeCheckMovingSlow);
    badgeCheck.style.top = '';
    badgeCheck.style.right = '';

    if (typeof targetElement.get !== 'undefined') {
      targetElement = targetElement.get(0);
    }
    var badgeCheckRect = badgeCheck.getBoundingClientRect();
    var targetRect = targetElement.getBoundingClientRect();
    var width = window.innerWidth;
    var positionTop = Math.round(targetRect.top + targetRect.height/2 - badgeCheckRect.height/2 - badgeCheckRect.top + parseInt(window.getComputedStyle(badgeCheck).getPropertyValue('top')));
    var badgeRightTmp = parseInt(window.getComputedStyle(badgeCheck).getPropertyValue('right'));
    var positionRight1 = Math.round(width - targetRect.left - targetRect.width - (width - badgeCheckRect.left) + badgeCheckRect.width/2 + badgeRightTmp);
    var positionRight2 = Math.round(positionRight1 + targetRect.width/2);

    badgeCheck.style.top = parseInt(positionTop) + 'px';
    badgeCheck.style.right = parseInt(!!quickadd ? positionRight2 : positionRight1) + 'px';
    timer = setTimeout(function () {
      badgeCheck.classList.add(classBadgeCheckVisible);
      badgeCheck.classList.add(classBadgeCheckMovingFast);
      setTimeout(function() {
        badgeCheck.style.right = parseInt(positionRight2) + 'px';
      }, 0);
      timer = setTimeout(function () {
        badgeCheck.classList.add(classBadgeCheckMovingSlow);
        badgeCheck.classList.remove(classBadgeCheckMovingFast);
        setTimeout(function () {
          badgeCheck.style.top = '';
          badgeCheck.style.right = '';
        }, 0);
        timer = setTimeout(function () {
          loadCount().then(function () {
            badgeCheck.classList.remove(classBadgeCheckVisible);
            badgeCheck.classList.remove(classBadgeCheckMovingSlow);
            if (typeof onFinish === 'function') {
              onFinish();
            }
          });
        }, 750);
      }, 250);
    }, 300);
  }

  return {
    showCheck: showCheck,
    loadCount: loadCount
  };

})();

//
// FLYOUT
//
var mainFlyoutMenu = (function () {

  // var backdrop = document.getElementById('oa-bckdrp19-flyout');
  // var classBackdropShow = 'oa-bckdrp19--show';

  var selectorMainLink = 'a.oa-hdr19-main__left__link',
      // Not tag-qualified: the "Accessibility" entry is a button element, it navigates nowhere.
      selectorFlyoutLink = '.oa-hdr19-main__flyout__left__link',
      selectorFlyoutGroup = '.oa-hdr19-main__flyout__right',
      classFlyout = 'oa-hdr19-main__flyout',
      classMainLinkActive = 'oa-hdr19-main__left__link--active',
      classFlyoutActive = 'oa-hdr19-main__flyout--active',
      classFlyoutLinkActive = 'oa-hdr19-main__flyout__left__link--active',
      classFlyoutGroupActive = 'oa-hdr19-main__flyout__right--active',
      classHeaderNavOpen = 'oa-hdr19--nav-open',
      // Hover-intent on open. On close, a short grace period so the pointer can
      // cross the sliver between a nav link and the panel below it without
      // kicking off a fade that then has to be cancelled (visible flicker).
      mouseInDelay = 140,
      mouseOutDelay = 50,
      // Match transparent header CSS transition (225ms)
      flyoutFadeDuration = 0.225,
      // Let megamenu start fading first; release top bar shortly after
      navCloseTrailDelay = 50;

  var mainLeftLinks,
      mouseOutTimer,
      mouseInTimer,
      navCloseTrailTimer,
      closingFlyouts = null,
      // Set only while focus is being put back on a main link deliberately.
      suppressFocusOpen = false,
      // Reset callbacks owned by the close currently in flight. Run when the
      // close completes, discarded when it is cancelled (panel stays open).
      pendingCloseCallbacks = [];

  function getHeaderEl () {
    return document.getElementById('oa-hdr19');
  }

  function setHeaderNavOpen (isOpen) {
    var headerEl = getHeaderEl();
    if (!headerEl) return;

    if (isOpen) {
      headerEl.classList.add(classHeaderNavOpen);
    } else {
      headerEl.classList.remove(classHeaderNavOpen);
    }
  }

  function getFlyoutForLeftLink (element) {
    return element.dataset.href && element.dataset.href.substr(0, 1) === '#' && document.getElementById(element.dataset.href.substr(1));
  }

  function isFlyoutForLeftLink (flyout) {
    return flyout && flyout.classList.contains(classFlyout);
  }

  function getFlyoutLeftLinks (flyout) {
    return Array.prototype.slice.call(flyout.querySelectorAll(selectorFlyoutLink)); 
  }

  function getFlyoutRightGroups (flyout) {
    return Array.prototype.slice.call(flyout.querySelectorAll(selectorFlyoutGroup));
  }

  function resetMainTimeout () {
    if (mouseOutTimer) {
      clearTimeout(mouseOutTimer);
      mouseOutTimer = null;
    }
  }

  function resetMouseInTimeout () {
    if (mouseInTimer) {
      clearTimeout(mouseInTimer);
      mouseInTimer = null;
    }
  }

  function resetNavCloseTrailTimeout () {
    if (navCloseTrailTimer) {
      clearTimeout(navCloseTrailTimer);
      navCloseTrailTimer = null;
    }
  }

  function flushPendingCloseCallbacks () {
    var callbacks = pendingCloseCallbacks;
    pendingCloseCallbacks = [];
    callbacks.forEach(function (callback) {
      callback();
    });
  }

  function discardPendingCloseCallbacks () {
    pendingCloseCallbacks = [];
  }

  // gsap.getProperty can legitimately return 0 — don't let `||` swallow it.
  function flyoutProperty (flyout, property, fallback) {
    var value = Number(gsap.getProperty(flyout, property));
    return isNaN(value) ? fallback : value;
  }

  // If the pointer returns to a panel (or to that panel's own nav link) while a
  // close fade has started, restore it. `flyout` scopes the check to what the
  // pointer actually entered — hovering a *different* nav link, or one with no
  // panel at all, must let the outgoing panel keep closing instead of snapping
  // it back to full opacity. Cancelling the pending timers is still correct in
  // every case: the pointer is inside the header, so whatever it lands on owns
  // the next open/close decision.
  function cancelFlyoutClose (flyout) {
    resetMainTimeout();
    resetNavCloseTrailTimeout();

    if (!closingFlyouts || !closingFlyouts.length) {
      return;
    }

    if (closingFlyouts.indexOf(flyout) === -1) {
      return;
    }

    killFlyoutTimeline(false);
    // The close was cancelled, so its sub-nav reset must not run — the panel
    // keeps the sub-category the user had selected.
    discardPendingCloseCallbacks();

    closingFlyouts.forEach(function (flyout) {
      flyout.classList.add(classFlyoutActive);
      gsap.set(flyout, {
        display: 'block',
        visibility: 'visible',
        opacity: 1,
        y: 0,
        clearProps: 'pointerEvents'
      });
    });

    var relatedLink = mainLeftLinks.find(function (link) {
      var flyout = getFlyoutForLeftLink(link);
      return closingFlyouts.indexOf(flyout) !== -1;
    });

    if (relatedLink) {
      relatedLink.classList.add(classMainLinkActive);
    }

    closingFlyouts = null;
    setHeaderNavOpen(true);
  }

  function killFlyoutTimeline (shouldClear) {
    if (flyoutTimeline) {
      flyoutTimeline.kill();
      flyoutTimeline = null;
    }

    if (shouldClear === false) {
      return;
    }

    document.querySelectorAll('.' + classFlyout).forEach(function (flyout) {
      gsap.set(flyout, { clearProps: 'all' });
    });
  }

  // Hides every panel immediately. Deliberately leaves
  // `oa-hdr19-main__left--active` alone: that class means "the megamenu shell
  // is on screen" and gates the entrance fade in setMainLeftActive(), so that
  // swapping between top-level links only swaps the contents instead of
  // re-fading the whole shell. It is cleared by the animated close, which is
  // the only path that ends with no panel on screen — every caller of this
  // function opens a panel again in the same tick.
  function finishRemoveMainLeftActive () {
    mainLeftLinks.forEach(function (e) {
      var flyout = getFlyoutForLeftLink(e);
      if (!isFlyoutForLeftLink(flyout)) {
        return;
      }
      e.classList.remove(classMainLinkActive);
      flyout.classList.remove(classFlyoutActive);
    });

    document.querySelectorAll('.' + classFlyout).forEach(function (flyout) {
      gsap.set(flyout, { clearProps: 'all' });
    });

    setHeaderNavOpen(false);
  }

  function removeMainLeftActive (options) {
    options = options || {};
    var animate = options.animate === true;
    var activeFlyouts = Array.prototype.slice.call(
      document.querySelectorAll('.' + classFlyout + '.' + classFlyoutActive)
    );

    if (typeof options.onComplete === 'function') {
      pendingCloseCallbacks.push(options.onComplete);
    }

    // Also catch panels mid-close (classes already removed, GSAP still showing
    // them). The close already in flight owns the queued callbacks — running
    // them here would reset the sub-nav while the panel is still visible.
    if (animate && activeFlyouts.length === 0 && closingFlyouts && closingFlyouts.length) {
      return;
    }

    if (animate && activeFlyouts.length > 0) {
      killFlyoutTimeline(false);
      resetNavCloseTrailTimeout();
      closingFlyouts = activeFlyouts;
      // Keep top bar solid briefly while megamenu starts fading, then release it
      setHeaderNavOpen(true);
      navCloseTrailTimer = setTimeout(function () {
        navCloseTrailTimer = null;
        setHeaderNavOpen(false);
      }, navCloseTrailDelay);

      mainLeftLinks.forEach(function (e) {
        e.classList.remove(classMainLinkActive);
      });

      activeFlyouts.forEach(function (flyout) {
        flyout.classList.remove(classFlyoutActive);
        gsap.set(flyout, {
          display: 'block',
          visibility: 'visible',
          // A panel that is on its way out must not swallow the pointer:
          // without this, dragging the cursor down over the fading panel would
          // hit its mouseenter and re-open the menu the user is dismissing.
          pointerEvents: 'none',
          opacity: flyoutProperty(flyout, 'opacity', 1),
          y: flyoutProperty(flyout, 'y', 0)
        });
      });

      flyoutTimeline = gsap.timeline({
        onComplete: function () {
          flyoutTimeline = null;
          closingFlyouts = null;
          resetNavCloseTrailTimeout();
          setHeaderNavOpen(false);
          activeFlyouts.forEach(function (flyout) {
            gsap.set(flyout, { clearProps: 'all' });
          });

          var mainLeft = document.querySelector('.oa-hdr19-main__left');
          if (mainLeft) {
            mainLeft.classList.remove('oa-hdr19-main__left--active');
          }

          flushPendingCloseCallbacks();
        }
      });

      activeFlyouts.forEach(function (flyout) {
        flyoutTimeline.to(flyout, {
          opacity: 0,
          y: -8,
          duration: flyoutFadeDuration,
          ease: 'power2.inOut'
        }, 0);
      });

      return;
    }

    closingFlyouts = null;
    resetNavCloseTrailTimeout();
    // `false` — finishRemoveMainLeftActive() already clears inline props on
    // every flyout, so letting killFlyoutTimeline() sweep too would do the
    // whole document query + clearProps twice on every hover-open.
    killFlyoutTimeline(false);
    finishRemoveMainLeftActive();

    flushPendingCloseCallbacks();
  }

  function setMainLeftActive (element) {
    var flyout = getFlyoutForLeftLink(element);
    if (!isFlyoutForLeftLink(flyout)) {
      return;
    }

    setHeaderNavOpen(true);

    document.querySelectorAll(selectorFlyoutLink).forEach(link => {
        link.classList.remove(classFlyoutLinkActive);
    });


    
    element.classList.add(classMainLinkActive);
    flyout.classList.add(classFlyoutActive);
    const flyoutWrapper = document.querySelector('.oa-hdr19-main__flyout.oa-hdr19-main__flyout--active'); 
    const targetLink = flyout.querySelector(selectorFlyoutLink);

    if(document.querySelector('html').classList.contains('header-version--a')){
    document.querySelectorAll(selectorFlyoutGroup).forEach(el => {
      el.classList.remove(classFlyoutGroupActive);
    });
  }

    if (flyoutWrapper && flyout && targetLink) {
      targetLink.classList.add(classFlyoutLinkActive);

      const leftLinks = flyout.querySelectorAll(".oa-hdr19-main__flyout__left__link");
      const underline = targetLink.querySelector(".underline-bar");
      const innerLeft = flyout.querySelector(".oa-hdr19-main__flyout__inner-left");

      const groupEls = flyout.querySelectorAll(selectorFlyoutGroup);
      const mainFlyoutContainer = document.querySelector('.oa-hdr19-main__left');
      



      if (flyoutTimeline) {
        killFlyoutTimeline();
      }

        document.querySelectorAll(".oa-hdr19-main__flyout__inner-left").forEach(link => {
         link.removeAttribute("style");
        });

        document.querySelectorAll(".oa-hdr19-main__flyout__right--img").forEach(img => {
         img.querySelector('.oa-picture-wrapper').removeAttribute("style");
         img.classList.remove('oa-hdr19-main__flyout__right--img--no-animation');
        });

        /*document.querySelectorAll('.oa-hdr19-main__flyout__right--img--animation').forEach(el => {
              el.classList.remove('oa-hdr19-main__flyout__right--img--no-animation');
            });
            */
        

        const items = document.querySelectorAll('#flyout-shop .oa-hdr19-main__flyout__right');



        flyoutTimeline = gsap.timeline({
          onComplete: () => {
          }
        });

        

      // 1. Animate flyout container (slide down & fade)
      // CSS handles display via --active; do not tween display (that caused stuck-open races).
      // Duration matches transparent header CSS (225ms) so top bar + panel stay in sync.
      if (mainFlyoutContainer && !mainFlyoutContainer.classList.contains('oa-hdr19-main__left--active')) {
        mainFlyoutContainer.classList.add('oa-hdr19-main__left--active');
        flyoutWrapper.querySelector('.oa-hdr19-main__flyout__right').classList.add('oa-hdr19-main__flyout__right--active');
        flyoutTimeline.fromTo(
          flyoutWrapper,
          { opacity: 0, y: -8 },
          {
            opacity: 1,
            y: 0,
            duration: flyoutFadeDuration,
            ease: "power2.inOut",
            onComplete: function () {
              if (!flyoutWrapper.classList.contains(classFlyoutActive)) {
                gsap.set(flyoutWrapper, { clearProps: 'all' });
              }
            }
          }
        );
      }else{
        flyoutWrapper.querySelector('.oa-hdr19-main__flyout__right').classList.add('oa-hdr19-main__flyout__right--active');
      }

      // 2. Animate all left links
      if(false){
      flyoutTimeline.fromTo(
        leftLinks,
        { opacity: 0, x: -20 },
        {
          opacity: 1,
          x: 0,
          duration: 0.4,
          ease: "power2.out",
          stagger: 0.1
        }
      );
    }
      // 3. Underline bar animation
      if (underline && false) {
        flyoutTimeline.fromTo(
          underline,
          { width: "0%", opacity: 0 },
          { width: "100%", opacity: 1, duration: 0.2, ease: "power2.out" }
        );
      }

      // 4. Inner content area animation (right side)
      if (innerLeft && false) {
        innerLeft.style.visibility = "visible";
        flyoutTimeline.fromTo(
          innerLeft,
          { opacity: 0, x: -20 },
          { opacity: 1, x: 0, duration: 0.4, ease: "power2.out" }
        );
      }
      
    }

  }

  function setFlyoutLeftActive (flyoutRightGroups, element) {
    var href = element.dataset.href || element.getAttribute('href');
    flyoutRightGroups.forEach(function (e) {
      if (e.hasAttribute('id')) {
        if (e.id === href.substr(1)) {
          e.classList.add(classFlyoutGroupActive);
        } else if (e.classList.contains(classFlyoutGroupActive)) {
          e.classList.remove(classFlyoutGroupActive);
        }
      }
    });
    if (href.substr(0, 1) === '#') {
      element.classList.add(classFlyoutLinkActive);
    }
  }

  function removeFlyoutLeftActive (flyoutLeftLinks, except) {
    flyoutLeftLinks.forEach(function (e) {
      if (e !== except && e.classList.contains(classFlyoutLinkActive)) { 
        e.classList.remove(classFlyoutLinkActive); 
      }
    });
  }

  // TODO: use one flyout and toggle children visibility

  // oa-a11y-controls.js owns the query; it is deferred, so it exists by the time the keydown
  // handler below can run. Missing means the asset failed to load — let Tab do its default.
  function focusablesIn (root) {
    return window.oaA11yControls ? window.oaA11yControls.focusables(root) : [];
  }

  // :focus-visible means "not focused by pointer". Safari before 15.4 lacks it and falls back to theme.liquid's
  // oa-pointer modality flag — returning true there would open the megamenu on every mouse click.

  // Visible only: mainLeftLinks also holds the hidden header version's links, and focusing one is a no-op.
  function nextVisibleLink (link) {
    return mainLeftLinks.slice(mainLeftLinks.indexOf(link) + 1).find(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
  }

  function isKeyboardFocus (element) {
    try {
      return element.matches(':focus-visible');
    } catch (e) {
      return !document.documentElement.classList.contains('oa-pointer');
    }
  }

  // Stops a main link's focus handler re-opening the panel Escape/Shift+Tab just left.
  // focus() dispatches synchronously, so the flag is only set for that one call.
  function focusWithoutReopening (element) {
    suppressFocusOpen = true;
    element.focus();
    suppressFocusOpen = false;
  }

  // Shared by hover and focus. Hover reaches it through a 140ms intent timer; focus does not,
  // because focus moves one deliberate element at a time and the delay is pure lag.
  function openFlyoutFor (element, flyout) {
    // Links without a panel (version B: Loyalty Club, About, Blogs) must close for real: the non-animated
    // close keeps the shell flag set for a next panel, which would kill the entrance fade from then on.
    if (!isFlyoutForLeftLink(flyout)) {
      removeMainLeftActive({ animate: true });
      return;
    }

    removeMainLeftActive();
    setMainLeftActive(element);
  }

  function onMainLeftLinkMouseEnter (element) {
    if (window.vuesearch && window.vuesearch.visible) {
      return;
    }

    var flyout = getFlyoutForLeftLink(element);

    // Intentional hover: cancel this link's own close, wait briefly before opening
    cancelFlyoutClose(flyout);
    resetMouseInTimeout();
    mouseInTimer = setTimeout(function () {
      mouseInTimer = null;
      openFlyoutFor(element, flyout);
    }, mouseInDelay);
  }

  function onMainLeftLinkFocus (element) {
    if (suppressFocusOpen || (window.vuesearch && window.vuesearch.visible)) {
      return;
    }
    // Keyboard only: a click also focuses the link, and opening here would skip the hover intent and
    // flash the megamenu before navigating. Pointers go through onMainLeftLinkMouseEnter.
    if (!isKeyboardFocus(element)) {
      return;
    }

    var flyout = getFlyoutForLeftLink(element);
    cancelFlyoutClose(flyout);
    resetMouseInTimeout();
    openFlyoutFor(element, flyout);
  }

  function onMainLeftLinkMouseLeave (flyoutLeftLinks, flyoutRightGroups) {
    resetMouseInTimeout();
    resetMainTimeout();
    mouseOutTimer = setTimeout(function () {
      resetMainTimeout();
      removeMainLeftActive({
        animate: true,
        onComplete: function () {
          if (flyoutRightGroups && flyoutLeftLinks && flyoutLeftLinks[0]) {
            removeFlyoutLeftActive(flyoutLeftLinks, null);
            setFlyoutLeftActive(flyoutRightGroups, flyoutLeftLinks[0]);
          }
        }
      });
    }, mouseOutDelay);
  }


  document.addEventListener('DOMContentLoaded', function () {
    mainLeftLinks = Array.prototype.slice.call(document.querySelectorAll(selectorMainLink));
    mainLeftLinks.forEach(function (element) {
      var flyout = getFlyoutForLeftLink(element);
      var hasFlyout = isFlyoutForLeftLink(flyout);
      // Resolved up front so the link's own mouseleave can be bound with the
      // same arguments as the panel's — bare, it received the MouseEvent as
      // `flyoutLeftLinks` and the sub-nav reset never ran on the common exit.
      var flyoutLeftLinks = hasFlyout ? getFlyoutLeftLinks(flyout) : null;
      var flyoutRightGroups = hasFlyout ? getFlyoutRightGroups(flyout) : null;

      element.addEventListener('mouseenter', onMainLeftLinkMouseEnter.bind(null, element), { passive: true });
      element.addEventListener('mouseleave', onMainLeftLinkMouseLeave.bind(null, flyoutLeftLinks, flyoutRightGroups), { passive: true });
      // `focus`, not `focusin` — these are the links themselves and it must not bubble.
      element.addEventListener('focus', onMainLeftLinkFocus.bind(null, element));
      element.addEventListener('click', function (event) {
        if (isMobile()) {
          event.preventDefault();
          return;
        }
        if (window.vuesearch && window.vuesearch.visible) {
          if (hasFlyout) {
            event.preventDefault();
            window.vuesearch.closeSearch();
            resetMouseInTimeout();
            resetMainTimeout();
            removeMainLeftActive();
            setMainLeftActive(element);
          }
        }
      });

      if (!hasFlyout) {
        return;
      }

      flyout.addEventListener('mouseenter', cancelFlyoutClose.bind(null, flyout), { passive: true });
      flyout.addEventListener('mouseleave', onMainLeftLinkMouseLeave.bind(null, flyoutLeftLinks, flyoutRightGroups), { passive: true });

      flyoutLeftLinks.forEach(function (element) {
        // Keyboard focus activates the sub-nav exactly as hover does.
        var activateSubNav = function () {
          resetMainTimeout();
          removeFlyoutLeftActive(flyoutLeftLinks, element);
          setFlyoutLeftActive(flyoutRightGroups, element);
        };
        element.addEventListener('mouseenter', activateSubNav, { passive: true });
        element.addEventListener('focus', activateSubNav);
        if (!element.dataset.href) {
          element.addEventListener('click', function (event) {
            event.preventDefault();
          });
        }
      });
    });

    var nav = document.querySelector('nav.oa-hdr19-main');
    if (nav) {
      // focusout fires before the next element takes focus, so relatedTarget is where focus is
      // going. Null means it left the document entirely — close in that case too.
      nav.addEventListener('focusout', function (event) {
        if (event.relatedTarget && nav.contains(event.relatedTarget)) {
          return;
        }
        var openLink = document.querySelector('.' + classMainLinkActive);
        var openFlyout = openLink && getFlyoutForLeftLink(openLink);
        // A click on empty space in the panel blurs to the body (no relatedTarget); while the pointer
        // rests on a main link or the panel, its own mouseleave owns the close. Tab always has a target.
        if (!event.relatedTarget &&
            (mainLeftLinks.some(function (link) { return link.matches(':hover'); }) ||
             (isFlyoutForLeftLink(openFlyout) && openFlyout.matches(':hover')))) {
          return;
        }
        // Resolved, not nulled: onMainLeftLinkMouseLeave only resets the sub-nav when it has
        // both, and Tabbing out must leave the panel in the same state the mouse exit does.
        if (isFlyoutForLeftLink(openFlyout)) {
          onMainLeftLinkMouseLeave(getFlyoutLeftLinks(openFlyout), getFlyoutRightGroups(openFlyout));
        } else {
          onMainLeftLinkMouseLeave(null, null);
        }
      });

      nav.addEventListener('keydown', function (event) {
        var isTab = event.key === 'Tab';
        var isDown = event.key === 'ArrowDown' || event.key === 'Down';
        if (!isTab && !isDown && event.key !== 'Escape' && event.key !== 'Esc') {
          return;
        }
        // Read before closing: removeMainLeftActive strips the active class synchronously.
        var active = document.querySelector('.' + classMainLinkActive);

        // ArrowDown is the way into a panel, re-opening it if Escape closed it.
        if (isDown) {
          var own = mainLeftLinks.indexOf(event.target) !== -1 && getFlyoutForLeftLink(event.target);
          if (!isFlyoutForLeftLink(own)) {
            return;
          }
          if (event.target !== active) {
            openFlyoutFor(event.target, own);
          }
          var inside = focusablesIn(own);
          if (inside.length) {
            event.preventDefault();
            inside[0].focus();
          }
          return;
        }

        if (!isTab) {
          resetMouseInTimeout();
          resetMainTimeout();
          removeMainLeftActive({ animate: true });
          // Escape returns focus to the link that owned the panel. With no panel open, do nothing —
          // focusing the first link would open a menu instead of closing one.
          if (active) {
            focusWithoutReopening(active);
          }
          return;
        }

        // The panels sit after the whole list of main links, so Tab and Shift+Tab have to be
        // routed between a panel and the link that owns it.
        var flyout = active && getFlyoutForLeftLink(active);
        if (!isFlyoutForLeftLink(flyout)) {
          return;
        }
        if (event.target === active && !event.shiftKey) {
          // Tab steps over the open panel, or its links (67 in Shop alone) all stand between the
          // logo and the cart. ArrowDown above is the way in. Only past the last link is a scan needed.
          var after = nextVisibleLink(active);
          if (!after) {
            var stops = focusablesIn(document.body);
            after = stops.slice(stops.indexOf(active) + 1).find(function (el) {
              return !flyout.contains(el);
            });
          }
          if (after) {
            event.preventDefault();
            after.focus();
          }
          return;
        }
        // Measured only from inside the panel, where the first and last item are the ones routed.
        var items = flyout.contains(event.target) ? focusablesIn(flyout) : [];
        if (!items.length) {
          return;
        }
        if (event.target === items[0] && event.shiftKey) {
          event.preventDefault();
          focusWithoutReopening(active);
        } else if (event.target === items[items.length - 1] && !event.shiftKey) {
          // The later panels are display:none, so default Tab would skip the remaining main links.
          // Out of visible links, let Tab leave the nav.
          var next = nextVisibleLink(active);
          if (next) {
            event.preventDefault();
            next.focus();
          }
        }
      });
    }
  }, { passive: true });

  return {};
})();

//
// BOTTOM SLIDER
//
var bottomSlider = (function () {
  var sliderId = '#oa-hdr19-bottom-swiper';
  var bottomEl = document.getElementById(sliderId.slice(sliderId.indexOf('#') + 1));

  if (!bottomEl) {
    return; 
  }

  var bottomElContainer = bottomEl.querySelector('.oa-hdr19-bottom__container');
  var swiper;

  function initSlider () {
    var isSlider = bottomEl.className.indexOf('swiper-container-initialized') !== -1;
    if (isSlider) {
      return;
    }
    swiper = new Swiper(bottomEl, {
      on: {
        init: function () {
          var swiper = this;
          var removeSlideIndices = [];
          swiper.slides.each(function (index, slide) {
            if (window.getComputedStyle(slide).getPropertyValue('display') !== 'none') {
              return; 
            }
            removeSlideIndices.push(parseInt(swiper.$(slide).attr('data-swiper-slide-index'), 10));
          });
          swiper.removeSlide(removeSlideIndices);
          swiper.update();
        },
      },
      navigation: {
        nextEl: sliderId + ' + .oa-hdr19-bottom__slider__nav .oa-hdr19-bottom__slider__nav-next',
        prevEl: sliderId + ' + .oa-hdr19-bottom__slider__nav .oa-hdr19-bottom__slider__nav-prev',
        disabledClass: 'oa-hdr19-bottom__slider__nav--disabled',
        hiddenClass: 'oa-hdr19-bottom__slider__nav--disabled'
      },
      slidesPerView: 1,
      spaceBetween: 1,
      loop: true,
      speed: 500,
      roundLengths: true, //prevent blurry text
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        invert: true
      },
      autoplay: {
        delay: 5000
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.GeoRedirect.fetchData(function (data) {
      var classList = document.documentElement.classList;
      var shipping1El, shipping2El;

      if (classList.contains('oa-de')) {
        switch (data.country_code) {
            case 'LI':
              shipping1El = bottomElContainer.querySelector('.oa-header_shipping1-text');
              if (shipping1El) {
                shipping1El.innerText = 'Kostenloser Standard Versand ab 90 €';
              }
              shipping2El = bottomElContainer.querySelector('.oa-header_shipping2-text');
              if (shipping2El) {
                shipping2El.closest('.swiper-slide').remove();
              }
              break;
          case 'CH':
            shipping1El = bottomElContainer.querySelector('.oa-header_shipping1-text');
            if (shipping1El) {
              shipping1El.innerText = 'Kostenloser Express Versand ab 150 €';
            }
            shipping2El = bottomElContainer.querySelector('.oa-header_shipping2-text');
            if (shipping2El) {
              shipping2El.closest('.swiper-slide').remove();
            }
            break;
        }
      } else if (classList.contains('oa-uk')) {
        /* switch (data.country_code) {
          default:
            var loyaltyClubEl;
            loyaltyClubEl = bottomElContainer.querySelector('.img-bestpoints');
             if (loyaltyClubEl) {
              loyaltyClubEl.closest('.swiper-slide').remove();
            }
            break;
        } */
      } else if (classList.contains('oa-eu')) {
        switch (data.country_code) {
          case 'FR':
          case 'IE':
            shipping1El = bottomElContainer.querySelector('.oa-header_shipping1-text');
            if (shipping1El) {
              shipping1El.innerText = 'Free standard shipping for orders over €59';
            }
            shipping2El = bottomElContainer.querySelector('.oa-header_shipping2-text');
            if (shipping2El) {
              shipping2El.innerText = 'Free express shipping for orders over €99';
            }
            break;
          default:
            shipping2El = bottomElContainer.querySelector('.oa-header_shipping2-text');
            if (shipping2El) {
              shipping2El.closest('.swiper-slide').remove();
            }
            break;
        }
      } else if (classList.contains('oa-com')) {
        switch (data.country_code) {
          case 'CN':
            shipping1El = bottomElContainer.querySelector('.oa-header_shipping1-text');
            if (shipping1El) {
              shipping1El.closest('.swiper-slide').remove();
            }
            break;
        }
      }
      bottomEl.style.opacity = 1;
      if (swiper) {
        swiper.update(); 
      }
    });

    setTimeout(initSlider, 1000);

    window.addEventListener('resize', function () {
      initSlider();
    }, { passive: true });

  }, { passive: true });
})();

//
// BLOG
//
document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('oa-blog')) {
    var selectorMainLink = '.oa-hdr19-main__left__link',
        classMainLinkActive = 'oa-hdr19-main__left__link--active',
        mouseOutDelay = 250;

    var mainLeftLinks,
        activeLeftLink,
        mouseOutTimer;

    mainLeftLinks = Array.prototype.slice.call(document.querySelectorAll(selectorMainLink));

    activeLeftLink = mainLeftLinks.filter(function (element) {
      return element.classList.contains(classMainLinkActive);
    })[0];

    function resetMainTimeout () {
      if (mouseOutTimer) { 
        clearTimeout(mouseOutTimer);
      }
    }

    function onMainLeftLinkMouseEnter (element) {
      resetMainTimeout();
      mainLeftLinks.forEach(function (e) {
        if (e !== element && e.classList.contains(classMainLinkActive)) { 
          e.classList.remove(classMainLinkActive); 
        }
      });
      element.classList.add(classMainLinkActive);
    }

    function onMainLeftLinkMouseLeave () {
      resetMainTimeout();
      mouseOutTimer = setTimeout(function () {
        resetMainTimeout();
        mainLeftLinks.forEach(function (e) {
          if (e.classList.contains(classMainLinkActive)) { 
            e.classList.remove(classMainLinkActive); 
          }
        });
        if (typeof activeLeftLink !== 'undefined') {
          activeLeftLink.classList.add(classMainLinkActive);
        }
      }, mouseOutDelay);
    }

    mainLeftLinks.forEach(function (element) {
      element.addEventListener('mouseenter', onMainLeftLinkMouseEnter.bind(null, element), { passive: true });
      element.addEventListener('mouseleave', onMainLeftLinkMouseLeave, { passive: true });
    });
  }
}, { passive: true });

//
// TRANSPARENCY
//
var transparency = (function () {
  var elContentOffset,
      classTransparent = 'oa-hdr19--transparent',
      initialized = false,
      y = 0,
      o = 150;

  var throttledResize = throttle(50, handleResize);
  var throttledScroll = throttle(50, handleScroll);

  function hasClass() {
    return header.classList.contains(classTransparent);
  }

  function handleResize() {
    if (elContentOffset) {
      o = elContentOffset.offsetTop + 10 - header.offsetHeight;
    }
  }

  function handleScroll() {
    y = window.scrollY || window.pageYOffset;
    if (y >= o) {
      if (hasClass()) {
        header.classList.remove(classTransparent);
      }
    } else {
      if (!hasClass()) {
        header.classList.add(classTransparent);
      }
    }
  }

  function init() {

  }

  function enable(element) {
    if (element) {
      elContentOffset = element;
    }

    

    handleResize();
    handleScroll(); 
    if (initialized) {
      return; 
    }
    initialized = true;
    window.addEventListener('resize', throttledResize, { passive: true });
    window.addEventListener('scroll', throttledScroll, { passive: true });
  }

  function disable() {
    if (!initialized) return;
    window.removeEventListener('resize', throttledResize);
    window.removeEventListener('scroll', throttledScroll);
    initialized = false;
  }

  return {
    enable: enable,
    disable: disable,
    isEnabled: function() { return initialized; }
  };
})();

//
// RECHARGE FIX
//
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.indexOf('/tools/recurring') !== -1) {
    var ids = ['#header-sidenav', '#oa-hdr19-banner', '#oa-hdr19'],
        selector = ids.map(function(id) { return id + ' [href*="/tools/recurring"]'; }).join(', ');
    Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function(el) {
      el.href = el.href.replace(/.*#/, '#').replace(/&.*/, '');
    });
  }
if(window.location.pathname == '/' && $('html').hasClass('header-version--a')) {
  var hasUrlSearchQuery = false;
  try {
    var q = new URL(window.location.href).searchParams.get('q');
    hasUrlSearchQuery = !!(q && q.trim());
  } catch(e) {}
  if (!hasUrlSearchQuery) {
    window.oaHeader.enableTransparency(document.querySelector('.oa-hero-banner .oa-hero-banner__content .h2'));
  }
}else {
  /*
  $('.oa-hdr19').removeClass('oa-hdr19--transparent');
  $('.oa-content').removeClass('oa-content--transparent-header')
  window.oaHeader.disableTransparency();
  */
}

const flyoutElements = document.querySelectorAll('.header-version--a .oa-hdr19-main__flyout__right');

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'class'
    ) {
      const el = mutation.target;

      // Check if it's becoming active
      const isNowActive = el.classList.contains('oa-hdr19-main__flyout__right--active');
     
      const innerLeft = el.querySelector('.oa-hdr19-main__flyout__inner-left');
      const noImgAnimation = el.querySelector('.oa-hdr19-main__flyout__right--img').classList.contains('oa-hdr19-main__flyout__right--img--no-animation');
      const img = el.querySelectorAll('.oa-hdr19-main__flyout__right--img .oa-picture-wrapper');
      
      

      document.querySelectorAll('.oa-hdr19-main__flyout__right').forEach(flyout => {
        if (!flyout.classList.contains('oa-hdr19-main__flyout__right--active')) {
          const otherInnerLeft = flyout.querySelector('.oa-hdr19-main__flyout__inner-left');
          if (otherInnerLeft) {
            otherInnerLeft.style.visibility = '';
          }
        }
      });

      if (isNowActive && innerLeft.style.visibility !== 'visible') {
        if (innerLeft) {
          innerLeft.style.visibility = 'visible';
          gsap.fromTo(innerLeft,
            { opacity: 0, },
            { opacity: 1, duration: 0.8, ease: 'power2.out' }
          );
        }

        // Trigger equal height update only for flyout-about-us-loyalty
        if (el.id === 'flyout-about-us-loyalty' && typeof window.equalHeightInstance !== 'undefined') {
          window.equalHeightInstance.update();
        }
 if (!noImgAnimation && img.length){
        gsap.fromTo(
          img,
          {
            height: 0,
            clipPath: 'inset(50% 0 50% 0)',
          },
          {
            height: '100%',         
            clipPath: 'inset(0% 0% 0% 0%)', 
            duration: 0.6,
            ease: 'power4.out',
          }
        );
      }
       
      if (el.querySelector('.oa-hdr19-main__flyout__right--img').classList.contains('oa-hdr19-main__flyout__right--img--animation')){
        el.querySelector('.oa-hdr19-main__flyout__right--img').classList.add('oa-hdr19-main__flyout__right--img--no-animation')
        
      }



      }

    }

  });
});

// Attach observer to all flyout elements
flyoutElements.forEach(flyout => {
  observer.observe(flyout, { attributes: true });
});




}, { passive: true });

return {
  setCountryIcon: chooseRegion.setCountryIcon,
  showCartCheck: cartBadge.showCheck,
  loadCartCount: cartBadge.loadCount,
  enableTransparency: transparency.enable,
  disableTransparency: transparency.disable,
  isTransparencyEnabled: transparency.isEnabled
};

})();


window.abtest = window.abtest || {};

// PLP banner A/B test config
//
// `alwaysShow` and `alwaysHide` sit OUTSIDE the A/B test: setupPlpTileVersion
// never touches them, so those tiles render (or stay hidden) in both versions.
// They are matched case-insensitively in buildBannerGrid before any other guard.
//
// `showByVersion` is the test itself — a title listed under any version renders
// only while that version is active.
window.oaPlpTileConfig = {
  // Campaign film tiles — live in every version.
  alwaysShow: [
    'oner mode_lori_harvey_campaign film_video-version-b',
    'oner mode_lori_harvey_campaign film_outfit_1',
    'campaign_banner_vid-1-version-b',
    'campaign_banner_vid-2-version-b',
  ],
  // Retired editorial stills — never render, in any version.
  alwaysHide: [
    'campaign_banner_sleek-simple_2x2-version-a',
    'oner mode_lori_harvey_campaign film_video-version-a',
    'campaign_banner_everyday_ease_2x2-version-a',
  ],
  // Tiles pinned directly after a specific product tile. Position only — a title
  // listed here is neither shown nor hidden by it, the guards above still decide
  // that. Applied on the first render, and only when the anchor handle is in the
  // same Algolia response; otherwise the tile keeps its Algolia position.
  pinAfterHandle: {
    'sun_set_banner_campaign film_outfit_1':
      'airmove-1-2-zip-jacket-with-bonding-new-branding-oil-blue',
    'sun_set_banner_campaign film_outfit_2':
      'oner-seamless-mid-weight-fitted-1-2-zip-long-sleeve-top-energy-orange',
  },
  showByVersion: {
    a: [
      // Icon tiles
      'plp_tile_shop_the_look_1',
      'plp_tile_shop_the_look_2',
      'plp_tile_video_slider_1',
      'plp_tile_image_slider_1',
      'plp_tile_quote_1',
    ],
    b: []
  }
};

window.abtest.setupHeaderVersion = function (version) {
  version = 'a';
  if (version == 'a') {
    $('.oa-hdr19-main--a').show(0);
    $('.oa-hdr19-main--b').hide(0);
  } else {
    $('.oa-hdr19-main--b').show(0);
    $('.oa-hdr19-main--a').hide(0);
    $('.oa-hdr19').removeClass('oa-hdr19--transparent');
    if (window.oaHeader && typeof window.oaHeader.disableTransparency === 'function') {
      window.oaHeader.disableTransparency();
    }
  }
  $('html').removeClass('header-version--a header-version--b');
  $('html').addClass('header-version--' + version);

  $('.oa-hdr19').removeClass('oa-hdr19--version-a oa-hdr19--version-b');
  $('.oa-hdr19').addClass('oa-hdr19--version-' + version);
}

// Whether this page load is an early access one. `earlyaccess_content_show` in
// snippets/sale-settings.liquid reaches us as window.oaEarlyAccess, handed over
// by layout/theme.liquid — this file is served as a standalone asset and cannot
// read Liquid variables assigned in snippets.
window.abtest.isEarlyAccess = function () {
  return window.oaEarlyAccess === true;
};

// Applies a version and persists it. Anything other than 'b' means version a,
// the default for every shop — except during early access, which forces version
// b on everyone. Deciding WHICH version a visitor gets otherwise happens in the
// resolver below; this function only applies what it is handed.
window.abtest.setupPlpTileVersion = function (version) {
  var selectedVersion = version === 'b' ? 'b' : 'a';

  // Persist the choice so it stays consistent on later page loads, until it is
  // changed again — whether it came from the hash, the query param or a call.
  try { localStorage.setItem('oa_ab_plp_tile_version', selectedVersion); } catch (e) {}

  // Early access overrides whatever was selected, including a call from the A/B
  // tool. It lands after the write on purpose: the visitor keeps their own
  // selection stored, so they return to it once early access is over rather than
  // carrying a forced b into the next run.
  if (window.abtest.isEarlyAccess()) {
    selectedVersion = 'b';
  }

  window.oaPlpTileVersion = selectedVersion;
  $('html').removeClass('plp-banner-version--a plp-banner-version--b');
  $('html').addClass('plp-banner-version--' + selectedVersion);
};

(function () {
  var storageKey = 'oa_ab_plp_tile_version';

  // The version this visitor has selected, or null if they never have.
  // Order: #version-a / #version-b hash > ?plp_tile_ab=a|b > stored value.
  function readSelection () {
    var hash = (window.location.hash || '').toLowerCase();
    if (hash === '#version-a') return 'a';
    if (hash === '#version-b') return 'b';

    var fromQuery = '';
    try {
      fromQuery = (new URLSearchParams(window.location.search).get('plp_tile_ab') || '').toLowerCase();
    } catch (e) {}
    if (fromQuery === 'a' || fromQuery === 'b') return fromQuery;

    try {
      var stored = localStorage.getItem(storageKey);
      if (stored === 'a' || stored === 'b') return stored;
    } catch (e) {}

    return null;
  }

  // The version actually in effect — during early access that is b whatever the
  // visitor selected, the same rule setupPlpTileVersion applies.
  window.abtest.getPlpTileVersion = function () {
    if (window.abtest.isEarlyAccess()) return 'b';
    return readSelection() || 'a';
  };

  // Runs before algolia-collection renders its hits, so window.oaPlpTileVersion
  // and the html class are in place by the time the first tile is filtered.
  var selection = readSelection();

  // An explicit selection always wins over the shop default below — early access
  // then overrides both, in setupPlpTileVersion. The shop default is disabled —
  // re-enable it to send early access (iddh38) and non-US shops to version b,
  // but only for visitors who have never selected a version themselves.
  // if (!selection && (document.documentElement.classList.contains('iddh38') ||
  //                    !document.documentElement.classList.contains('oa-us'))) {
  //   selection = 'b';
  // }

  window.abtest.setupPlpTileVersion(selection || 'a');
})();

// Refer-a-friend block in the mobile nav (snippets/header-mobile-collapse.liquid).
// Version a is the control and keeps the loyalty club card; version b swaps that
// card for the refer-a-friend block. The CSS in header.scss does the swap, and
// only where the block was actually rendered — see the note there.
//
// Who gets which version is decided externally: the A/B tool calls
// setupReferFriendVersion with the version it assigned this visitor. Nothing here
// splits traffic. Version b is the default, for visitors the tool has not assigned
// yet. This function only applies and persists what it is handed — the resolver
// below decides what a visitor starts the page load on. Anything other than an
// explicit 'a' means version b.
window.abtest.setupReferFriendVersion = function (version) {
  var selectedVersion = version === 'a' ? 'a' : 'b';

  // Persist the choice so it stays consistent on later page loads, until it is
  // changed again — whether it came from the A/B tool, the hash or the query param.
  try { localStorage.setItem('oa_ab_refer_friend_version', selectedVersion); } catch (e) {}

  window.abtest.referFriendVersion = selectedVersion;

  var root = document.documentElement;
  root.classList.remove('refer-friend-version--a', 'refer-friend-version--b');
  root.classList.add('refer-friend-version--' + selectedVersion);
};

(function () {
  var storageKey = 'oa_ab_refer_friend_version';

  // Whether the test is running: refer_friend_ab_test_active in
  // snippets/sale-settings.liquid, handed to us by layout/theme.liquid. While it
  // is false the stored version is ignored, so nobody carries an assignment from
  // a finished run into the next page load — everyone starts on the default.
  // It never overrides the A/B tool: a call made while the test is off still
  // applies, for that page load.
  var testActive = window.oaReferFriendTestActive === true;

  // The version this visitor is on, or null if they are on none yet.
  // Order: #refer-friend-a / #refer-friend-b hash > ?refer_friend_ab=a|b >
  // stored value.
  function readSelection () {
    var hash = (window.location.hash || '').toLowerCase();
    if (hash === '#refer-friend-a') return 'a';
    if (hash === '#refer-friend-b') return 'b';

    var fromQuery = '';
    try {
      fromQuery = (new URLSearchParams(window.location.search).get('refer_friend_ab') || '').toLowerCase();
    } catch (e) {}
    if (fromQuery === 'a' || fromQuery === 'b') return fromQuery;

    if (testActive) {
      try {
        var stored = localStorage.getItem(storageKey);
        if (stored === 'a' || stored === 'b') return stored;
      } catch (e) {}
    }

    return null;
  }

  window.abtest.getReferFriendVersion = function () {
    return readSelection() || 'b';
  };

  // Runs at parse time, before the nav can open, so the visitor is dressed in the
  // version they were last assigned rather than flashing the default first. The
  // A/B tool overrides it whenever it loads and assigns something else.
  window.abtest.setupReferFriendVersion(readSelection() || 'b');
})();



// Mobile image-swipe A/B test on the search surfaces — the header search dropdown
// and the search results page. Version a is the control with no swiping there;
// the collection PLP swipes in both versions. The A/B tool calls this with the
// version it assigned; anything other than an explicit 'b' means version a.
window.abtest.setupSearchSwipeVersion = function (version) {
  var selectedVersion = version === 'b' ? 'b' : 'a';

  // Persist so the version stays consistent on later page loads, until it is
  // changed again — whether it came from the A/B tool, the hash or the query param.
  try { localStorage.setItem('oa_ab_search_swipe_version', selectedVersion); } catch (e) {}

  window.abtest.searchSwipeVersion = selectedVersion;

  // Swiping is DOM rather than CSS, so a call arriving after the cards have
  // rendered has to reach PLPMobileSwipe — it builds or tears them down on this.
  document.dispatchEvent(new CustomEvent('oa:searchswipeversion', { detail: { version: selectedVersion } }));
};

(function () {
  var storageKey = 'oa_ab_search_swipe_version';

  // search_swipe_ab_test_active in snippets/sale-settings.liquid. While it is
  // false the stored version is ignored, so nobody carries an assignment out of
  // a finished run — but a call from the A/B tool still applies for that load.
  var testActive = window.oaSearchSwipeTestActive === true;

  // The version this visitor is on, or null if they are on none yet.
  // Order: #search-swipe-version-a / #search-swipe-version-b hash >
  // ?search_swipe_version=a|b > stored value.
  function readSelection () {
    var hash = (window.location.hash || '').toLowerCase();
    if (hash === '#search-swipe-version-a') return 'a';
    if (hash === '#search-swipe-version-b') return 'b';

    var fromQuery = '';
    try {
      fromQuery = (new URLSearchParams(window.location.search).get('search_swipe_version') || '').toLowerCase();
    } catch (e) {}
    if (fromQuery === 'a' || fromQuery === 'b') return fromQuery;

    if (testActive) {
      try {
        var stored = localStorage.getItem(storageKey);
        if (stored === 'a' || stored === 'b') return stored;
      } catch (e) {}
    }

    return null;
  }

  window.abtest.getSearchSwipeVersion = function () {
    return readSelection() || 'a';
  };

  // This file is a blocking script and plp-mobile-swipe.js is deferred, so the
  // version is settled before the first build pass runs. Only an actual
  // selection goes through setup — persisting the default would make the stored
  // value stop meaning "the version this visitor was assigned".
  var selection = readSelection();
  if (selection) {
    window.abtest.setupSearchSwipeVersion(selection);
  } else {
    window.abtest.searchSwipeVersion = 'a';
  }
})();


// PDP logo-version test — three ways to reach the other branding version of a product
// when a size sold out on the one being viewed. a = logo selector tabs, b = alternative
// module under the CTA, c = missing-stock popup.
//
// The default is version a on every store, US included. `version` is still nullable, and
// anything that is not an explicit a/b/c — including 'off', 'control' and undefined —
// turns the test off rather than falling back to a version that renders something.
// Unassigned means the feature does not exist: pdp-logo-versions.js returns before it
// fetches anything.
//
// opts.persist false applies a version without storing it, which is how the shop default
// stays a default instead of freezing onto every visitor who has been to the site once.
window.abtest.setupLogoVersionsVersion = function (version, opts) {
  // Tolerant of what a person types into the A/B tool: "A", " b ", "C" all resolve. Strict
  // equality against lowercase meant "A" fell through to null and silently turned the test
  // off, which looks identical to not being in it.
  var normalised = String(version === null || version === undefined ? '' : version).trim().toLowerCase();
  var selectedVersion = normalised === 'a' || normalised === 'b' || normalised === 'c' ? normalised : null;

  // Persist the choice so it stays consistent on later page loads. Off is stored as a
  // removal rather than a value: a visitor the tool has dropped out of the test should
  // read as never-assigned, not as assigned-to-nothing.
  try {
    if (selectedVersion) {
      if (!opts || opts.persist !== false) {
        localStorage.setItem('oa_ab_logo_versions_version', selectedVersion);
      }
    } else {
      localStorage.removeItem('oa_ab_logo_versions_version');
    }
  } catch (e) {}

  window.abtest.logoVersionsVersion = selectedVersion;

  var root = document.documentElement;
  root.classList.remove('logo-versions-version--a', 'logo-versions-version--b', 'logo-versions-version--c');
  if (selectedVersion) root.classList.add('logo-versions-version--' + selectedVersion);

  // The UI is built from data fetched at runtime, not revealed by CSS, so a call
  // arriving after the PDP has painted has to reach pdp-logo-versions.js — it builds
  // or tears down on this.
  document.dispatchEvent(new CustomEvent('oa:logoversionsversion', { detail: { version: selectedVersion } }));
};

(function () {
  var storageKey = 'oa_ab_logo_versions_version';

  // Whether the test is running: logo_versions_ab_test_active in
  // snippets/sale-settings.liquid, handed to us by layout/theme.liquid. While it is
  // false the stored version is ignored, so nobody carries an assignment from a
  // finished run into the next page load. It never overrides the A/B tool: a call made
  // while the test is off still applies, for that page load.
  var testActive = window.oaLogoVersionsTestActive === true;

  // Version a is simply the experience on every store, so it is the default rather than
  // something a tool has to assign. The A/B tool still overrides it per visitor.
  function shopDefault () {
    return 'a';
  }

  // 'a' | 'b' | 'c' picked deliberately, 'off' to be taken out, or null for nothing said.
  // Hash beats query beats a stored assignment.
  function explicitSelection () {
    var hash = (window.location.hash || '').toLowerCase();
    if (hash === '#logo-versions-a') return 'a';
    if (hash === '#logo-versions-b') return 'b';
    if (hash === '#logo-versions-c') return 'c';
    if (hash === '#logo-versions-off') return 'off';

    var fromQuery = '';
    try {
      fromQuery = (new URLSearchParams(window.location.search).get('logo_versions_ab') || '').toLowerCase();
    } catch (e) {}
    if (fromQuery === 'a' || fromQuery === 'b' || fromQuery === 'c') return fromQuery;
    if (fromQuery === 'off') return 'off';

    if (testActive) {
      try {
        var stored = localStorage.getItem(storageKey);
        if (stored === 'a' || stored === 'b' || stored === 'c') return stored;
      } catch (e) {}
    }

    return null;
  }

  // `persist` is what keeps the shop default from turning into a stored assignment. Writing
  // it would freeze today's default onto every non-US visitor, so changing it later would
  // reach nobody who had already been to the site.
  function resolve () {
    var explicit = explicitSelection();
    if (explicit === 'off') return { version: null, persist: true };
    if (explicit) return { version: explicit, persist: true };
    return { version: shopDefault(), persist: false };
  }

  // Still nullable — an explicit 'off' answers null, and pdp-logo-versions.js treats that
  // as "do nothing at all".
  window.abtest.getLogoVersionsVersion = function () {
    return resolve().version;
  };

  // This file is a blocking script and pdp-logo-versions.js is deferred, so the version
  // is settled before the feature's first guard runs.
  var initial = resolve();
  window.abtest.setupLogoVersionsVersion(initial.version, { persist: initial.persist });
})();
